import { getCore, putCore, postCore, patchCore, delCore } from "../utils/httpInterceptor";

const alertsService = {
  catalog: () => getCore("/api/core/alerts"),
  get: (alertCode) => getCore(`/api/core/alerts/${alertCode}`),
  update: (alertCode, body) => putCore(`/api/core/alerts/${alertCode}`, body),
  runNow: (alertCode) => postCore(`/api/core/alerts/${alertCode}/run-now`, {}),
  runLog: (alertCode, page = 0, size = 10) =>
    getCore(`/api/core/alerts/${alertCode}/run-log?page=${page}&size=${size}`),

  savedFilterSupportedEntities: () =>
    getCore("/api/core/alerts/saved-filters/supported-entities"),
  createSavedFilterAlert: (body) =>
    postCore("/api/core/alerts/saved-filters", body),
  mySavedFilterAlerts: () => getCore("/api/core/alerts/saved-filters/mine"),
  pendingSavedFilterAlerts: () =>
    getCore("/api/core/alerts/saved-filters/pending"),
  allSavedFilterAlerts: () => getCore("/api/core/alerts/saved-filters"),
  decideSavedFilterAlert: (id, body) =>
    postCore(`/api/core/alerts/saved-filters/${id}/decide`, body),
  updateSavedFilterAlert: (id, body) =>
    patchCore(`/api/core/alerts/saved-filters/${id}`, body),
  deleteSavedFilterAlert: (id) =>
    delCore(`/api/core/alerts/saved-filters/${id}`),
  runNowSavedFilterAlert: (id) =>
    postCore(`/api/core/alerts/saved-filters/${id}/run-now`, {}),
};

export default alertsService;
